import { findIndex, findLastIndex } from 'lodash';
import { Destination, TripTypes } from '@model/common';
import { FooterTypes, TemplateData, TemplateComponent, ComplexComponent, ComplexComponentTypes } from '@model/content';
import { AppVariant } from '@model/config/brands';
import { NavBarContainer } from '@components/navigation';
import { ComponentsContainer } from '@components/content';
import { PromoBannerContainer } from '@components/content/common';
import SearchTabsBar from '@components/search/SearchTabsBar';
import { Footer } from '@components/footer';
import { ComponentHandles } from '@util/content';

interface SidebarPageLayoutProps extends TemplateData {
  componentsData?: Array<any>;
  tripType?: TripTypes;
  path?: string;
  destination?: Destination;
  footerType?: FooterTypes;
  promoBannerTripType?: TripTypes;
}

const formatComponents = (components: Array<TemplateComponent>): Array<TemplateComponent> => {
  const openIdx = findIndex(
    components,
    (component) =>
      component.handle === ComponentHandles.GRID && 'type' in component && component.type === ComplexComponentTypes.OPEN
  );
  const closeIdx = findLastIndex(
    components,
    (component) =>
      component.handle === ComponentHandles.GRID &&
      'type' in component &&
      component.type === ComplexComponentTypes.CLOSE
  );

  if (openIdx === -1 || closeIdx === -1) {
    return components;
  }

  const gridContainerOpen: ComplexComponent = {
    handle: ComponentHandles.GRID_CONTAINER,
    type: ComplexComponentTypes.OPEN,
    path: ''
  };
  const gridContainerClose: ComplexComponent = {
    handle: ComponentHandles.GRID_CONTAINER,
    type: ComplexComponentTypes.CLOSE,
    path: ''
  };
  return components
    .slice(0, openIdx)
    .concat([gridContainerOpen])
    .concat(
      components
        .slice(openIdx, closeIdx + 1)
        .concat(gridContainerClose)
        .concat(components.slice(closeIdx + 1))
    );
};

export const SidebarPageLayout = ({
  components,
  componentsData,
  footerType,
  path,
  tripType,
  destination,
  promoBannerTripType
}: SidebarPageLayoutProps) => {
  const isWhiteLabel = AppVariant.isWhitelabel();
  const formattedComponents = formatComponents(components);

  return (
    <>
      <NavBarContainer renderSearch={<SearchTabsBar condensed />} />
      {!isWhiteLabel && promoBannerTripType && <PromoBannerContainer promoBannerTripType={promoBannerTripType} />}
      <ComponentsContainer
        components={formattedComponents}
        componentsData={componentsData}
        path={path}
        tripType={tripType}
        destination={destination}
        isWhiteLabel={isWhiteLabel}
      />
      <Footer type={footerType} hideReviews />
    </>
  );
};
